import React from 'react';
import { Route, Redirect, IndexRoute } from 'react-router';

import App from './App';
import Flags from './utils/Flags';
import HelpRoot from './components/helpCenter/HelpRoot';

import UAHelper from 'fk-cp-shared/utils/UAHelper';
import Prefetcher from 'fk-cp-common-components/utils/Prefetcher';
import clientStore from './clientStore';

let DwellTimeRouteTracker;
try {
	// eslint-disable-next-line @typescript-eslint/no-var-requires
	DwellTimeRouteTracker = require('./utils/dwell-time/DwellTimeRouteTracker').default;
} catch (e) {
	DwellTimeRouteTracker = null;
}

let firstLoadDone = false;

const removeInitialLoader = () => {
	if (firstLoadDone) {
		return;
	}
	const loader = document.getElementById('initialLoader');
	if (loader) {
		loader.parentElement.removeChild(loader);
	}
	firstLoadDone = true;
};

const changeHandler = function (prevRoute, nextRoute) {
	//Post redirection to homepage, close the HC so that back button doesn't get redirected anywhere..
	if (
		prevRoute &&
		prevRoute.location &&
		prevRoute.location.pathname === '/rv/help' &&
		nextRoute.location &&
		nextRoute.location.action === 'POP' &&
		!UAHelper._isMsite()
	) {
		window.location.href = '/';
	}
	
	if (nextRoute && nextRoute.location) {
		if (DwellTimeRouteTracker && typeof DwellTimeRouteTracker.onRouteChange === 'function') {
			try {
				DwellTimeRouteTracker.onRouteChange(prevRoute, nextRoute);
			} catch (e) {
				// eslint-disable-line no-empty
			}
		}
	}
};

function disableOmniture() {
	if (typeof window !== 'undefined' && window.omniture) {
		window.omniture = {
			...window.omniture,
			trackLink: () => {},
			trackPageView: () => {}
		};
	}
}

const asyncComponent = (bundle, bundlesToPrefetch) => (location, cb) => {
	bundle().then(component => {
		cb(null, component.default);
		removeInitialLoader();
		disableOmniture();
		if (bundlesToPrefetch) {
			Prefetcher.load(bundlesToPrefetch);
		}
	});
};

const getHelpCentreRoutesForPath = path => (
	<Route path={`(:locale/)${path}`} name="help" component={HelpRoot}>
		<IndexRoute
			getComponent={asyncComponent(() => import(/* webpackChunkName: "Help" */ './components/helpCenter/HelpV2'))}
		/>
		<Route
			path="selectOrder"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/TacticalHelpCentre/Orders')
			)}
		/>
		<Route
			path="orderHelp*"
			getComponent={asyncComponent(
				() => import(/* webpackChunkName: "Help" */ './components/helpCenter/OrderHelp'),
				['widOrderDetails']
			)}
		/>
		<Route
			path="otherHelp*"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/OtherHelp')
			)}
		/>
		<Route
			path="faqs*"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/Faq/faqs')
			)}
		/>
		<Route
			path="faqFinal"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/Faq/FaqFinal')
			)}
		/>
		<Route
			path="feedback"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/ContactUs/FeedBack')
			)}
		/>
		<Route
			path="email"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/ContactUs/EmailUs')
			)}
		/>
		<Route
			path="contactUs"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/ContactUs')
			)}
		/>
		<Route
			path="cmb"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/ContactUs/CallBack')
			)}
		/>
		<Route
			path="scmb"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/ContactUs/ScheduleCallBack')
			)}
		/>
		<Route
			path="postal"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/ContactUs/Postal')
			)}
		/>
		<Route
			path="search"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/SearchPage')
			)}
		/>
		<Route
			path="writeToUs"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/WriteToUs')
			)}
		/>
		<Route
			name="issuesPage"
			path="issues"
			getComponent={asyncComponent(() => import(/* webpackChunkName: "Help" */ './components/helpCenter/Issues'))}
		/>
		<Route
			name="trackIssue"
			path="trackIssue"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/TrackIssue')
			)}
		/>
		<Route
			name="writeUs"
			path="writeUs"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/ContactUs/WriteToUs')
			)}
		/>
		<Route
			path="narrowIntent/i/:helpPageId/:helpIssueName"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/HelpV2/NarrowIntent')
			)}
		/>
		<Route
			path=":helpIssueName/i/:helpPageId"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/HelpV2/NarrowIntent')
			)}
		/>
		<Route
			path="nonOrderIssues"
			getComponent={asyncComponent(() =>
				import(/* webpackChunkName: "Help" */ './components/helpCenter/HelpV2/NonOrderIssues')
			)}
		/>
	</Route>
);
const routes = (
	<Route path="/" component={App} onChange={changeHandler}>
		{/* <Redirect from="(:locale/)rv/help*" to="(:locale/)helpcentre*" /> */}
		{getHelpCentreRoutesForPath('rv/help')}
		<Redirect from="(:locale/)rv/help*" to="(:locale/)rv/help" />
		{getHelpCentreRoutesForPath('helpcentre')}
		<Redirect from="(:locale/)helpcentre*" to="(:locale/)helpcentre" />
		<Route path="(:locale/)rv">

			<Route
				name="orders"
				path="orders"
				store={clientStore}
				getComponent={asyncComponent(() => {
					return Flags.enableMOv4
						? import(
								/* webpackChunkName: "moV4" */ './components/app/MyOrdersPage/WidgetizedMyOrdersContainer'
						  )
						: import(/* webpackChunkName: "orders" */ './components/app/MyOrdersPage');
				}, ['widOrderDetails'])}
			/>
			<Route
				name="ordersSearch"
				path="orders/search"
				store={clientStore}
				getComponent={asyncComponent(() => {
					return Flags.enableMOv4
						? import(
								/* webpackChunkName: "orderSearch" */ './components/app/MyOrdersPage/WidgetizedMyOrdersContainer'
						  )
						: import(/* webpackChunkName: "orderSearch" */ './components/app/MyOrdersSearch');
				}, ['widOrderDetails'])}
			/>
			<Route
				name="orderdetails"
				path="orderDetails"
				store={clientStore}
				getComponent={({ location }, cb) => {
					asyncComponent(
						() =>
							import(
								/* webpackChunkName: "widOrderDetails" */ './components/app/OrderDetails/WidgetizedOrderDetailsContainer'
							),
						['orders', 'OrderHelp', 'RequestCancel', 'Returns']
					)(location, cb);
				}}
			/>
			<Redirect from="pay-prepaid/orderDetails" to="orderDetails" />
			<Route
				name="orderConfirmation"
				path="orderConfirmation"
				getComponent={asyncComponent(
					() =>
						Flags.enableOcV4 === 'true'
							? import(
									/* webpackChunkName: "widOrderconfirm" */ './components/app/OrderConfirmPage/WidgetizedOC/WidgetizedOrderConfirmationContainer'
							  )
							: import(
									/* webpackChunkName: "orderconfirm" */ './components/app/OrderConfirmPage/WidgetizedOC/NonWidgetizedOrderConfirmHOC'
							  ),
					['widOrderDetails']
				)}
			/>
			<Route
				name="orderConfirmation-old"
				path="orderConfirmation/orderresponse"
				getComponent={asyncComponent(() =>
					Flags.enableOcV4 === 'true'
						? import(
								/* webpackChunkName: "widOrderconfirm" */ './components/app/OrderConfirmPage/WidgetizedOC/WidgetizedOrderConfirmationContainer'
						  )
						: import(
								/* webpackChunkName: "orderconfirm" */ './components/app/OrderConfirmPage/WidgetizedOC/NonWidgetizedOrderConfirmHOC'
						  )
				)}
			/>
			<Route
				name="payoutMode"
				path="orders/payoutMode"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "cashbackMode" */ './components/android/CashbackMode')
				)}
			/>
			<Route
				name="returns"
				path="orders/returns"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "Returns" */ './components/android/Returns')
				)}
			/>
			<Route
				name="createAccount"
				path="orders/returns/createAccount"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "CreateBankAccount" */ './components/android/Returns/CreateBankAccount')
				)}
			/>
			<Route
				name="getifsc"
				path="orders/returns/getifsc"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "CreateBankAccount" */ './components/android/Returns/GetIfsc')
				)}
			/>

			<Route
				name="requestCancel"
				path="requestCancel"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "RequestCancel" */ './components/android/RequestCancelPage')
				)}
			/>
			<Route
				name="bankTnC"
				path="orders/bankTnC"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "CreateBankAccount" */ './components/android/BankTnC')
				)}
			/>
			<Route
				name="getSlots"
				path="getSlots"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "GetSlots" */ 'fk-cp-common-components/webComponents/V4/Android/returns/RescheduleCallBack'
					)
				)}
			/>

			<Route
				name="ndr"
				path="orders/ndr"
				getComponent={asyncComponent(() => import(/* webpackChunkName: "NDR" */ './components/app/NDR'))}
			/>
			<Route
				name="addressChange"
				path="orders/addressChangeV2"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "addressChangeV2" */ 'fk-cp-common-components/webComponents/V4/Android/ChangeAddressPage/v2/ChangeAddressPage'
					)
				)}
			/>
			<Route
				name="addressChangeAdd"
				path="orders/addressChange/add"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "addressChangeV2" */ './components/android/ChangeAddressPage/EditAddressPage/EditAddressPage'
					)
				)}
			/>
			<Route
				name="rescheduleSlots"
				path="orders/rescheduleSlots"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "RescheduleSlots" */ 'fk-cp-common-components/webComponents/V4/app/RescheduleDelivery/RescheduleSlots/RescheduleSlots'
					)
				)}
			/>
			<Route
				name="scheduleDelivery"
				path="orders/scheduleDelivery"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "ScheduleDelivery" */ './components/app/ScheduleDelivery/ScheduleDelivery'
					)
				)}
			/>
			<Route
				name="scheduleDelivery"
				path="orders/scheduleDeliveryps2"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "ScheduleDeliveryPS2" */ './components/app/ScheduleDelivery/ScheduleDeliveryPS2'
					)
				)}
			/>
			<Route
				name="offerTnc"
				path="orders/offerTnC"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "OfferTnC" */ 'fk-cp-common-components/webComponents/V4/common/OfferTandc/OfferTandc'
					)
				)}
			/>
			<Route
				name="trackOrder"
				path="trackorder"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "trackOrder" */ './components/app/TrackOrder/TrackOrderPage')
				)}
			/>
			<Route
				name="updateNeft"
				path="orders/updateNeft"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "updateNeft" */ './components/android/UpdateNeft')
				)}
			/>

			<Route
				name="addNewAccount"
				path="orders/updateNeft/addNewAccount"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "updateNeft" */ './components/android/UpdateNeft/AddNewBankAccount')
				)}
			/>
			<Route
				name="fetchIFSC"
				path="orders/updateNeft/addNewAccount/fetchIFSC"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "updateNeft" */ './components/android/UpdateNeft/FetchIfsc')
				)}
			/>
			<Route
				name="bankTnC"
				path="orders/updateNeft/addNewAccount/bankTnC"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "updateNeft" */ './components/android/UpdateNeft/UpdateNeftTnC')
				)}
			/>
			<Route
				name="updateIFSCSuccess"
				path="orders/updateNeft/success"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "updateNeft" */ './components/android/UpdateNeft/UpdateIFSCSuccess')
				)}
			/>
			<Route
				name="returnOnHold"
				path="orders/confirmDelivery"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "returnonholdpage" */ './components/app/ReturnOnHold/ReturnOnHoldPage')
				)}
			/>
			<Route
				path="orders/returns/troubleshooting"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "Troubleshooting" */ './components/android/Returns/Troubleshooting')
				)}
			/>
			<Route
				path="orders/returns/troubleshooting/issueLevels"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "Troubleshooting" */ './components/android/Returns/Troubleshooting/IssueLevels'
					)
				)}
			/>
			<Route
				name="shareOrder"
				path="orders/share"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "shareOrder" */ './components/app/ShareOrder')
				)}
			/>
			<Route
				name="returnRequestTracking"
				path="orderDetails/returns"
				getComponent={asyncComponent(() =>
					import(
						/* webpackChunkName: "returnRequestTracking" */ 'fk-cp-common-components/webComponents/V4/app/OrderDetails/ReturnRequestTracking'
					)
				)}
			/>
			<Route
				name="myChats"
				path="chats(/:chatId)"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "myChats" */ './components/app/ChatsPage/ChatsPage')
				)}
			/>
			<Route
				name="mediaUpload"
				path="orders/mediaUpload"
				getComponent={asyncComponent(() =>
					import(/* webpackChunkName: "mediaUpload" */ './components/common/MediaUploadPage')
				)}
			/>
		</Route>
	</Route>
);

export default routes;
